function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
export default {
  name: 'DatasourceDsTabUser',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          kdomain: null,
          ksubdomain: null,
          kbusiness_term: null
        };
      }
    }
  },
  computed: _objectSpread({
    filterDomain: function filterDomain() {
      return this.selectDomain;
    },
    filterSubDomain: function filterSubDomain() {
      var _this = this;
      var selectbSubdomain = this.selectSubdomain.filter(function (x) {
        return x.domain.includes(_this.kdomain);
      });
      return selectbSubdomain;
    },
    filterBusinessTerm: function filterBusinessTerm() {
      var _this2 = this;
      var selectbBusinessTerm = this.selectBusinessTerm ? this.selectBusinessTerm.filter(function (x) {
        return x.ksubdomain == _this2.ksubdomain;
      }) : [];
      return selectbBusinessTerm;
    },
    showButtonAttachment: function showButtonAttachment() {
      var userInfo = window.userInfo;
      var dataOperator = this.item.data_operator;
      var userRoles = userInfo.userRoles || [];
      return userRoles.includes(ROLES_LIST.ORG_DATA_STEWARD) || dataOperator === userInfo.email;
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'selectBusinessTerm'])),
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      inputUploadFile: null,
      domain_table: '',
      files: [],
      currentFile: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      kdomain: null,
      ksubdomain: null,
      kbusiness_term: null,
      bt_add: {
        kdomain: null,
        domain_description: '',
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      },
      headers: [{
        text: "N°",
        value: 'index'
      }, {
        text: 'Name',
        value: 'name'
      }, {
        text: 'Email',
        value: 'email'
      }, {
        text: 'Type',
        value: 'type'
      }, {
        text: 'Permission',
        value: 'access_right'
      }]
    };
  },
  created: function created() {
    this.domain_table = window.userInfo.domain;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files || [];
  },
  mounted: function mounted() {},
  methods: {}
};